import axios from "axios";
import { Constant } from "../../config";

export default {
  _getSummary: async (startDate, endDate, memberId, country, page, limit) => {
    const url = `${Constant.BASE_API}/monitor-smpp/`;
    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        start_date: startDate,
        end_date: endDate,
        member_id: memberId,
        search: country,
        page: page,
        limit: limit,
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return {};
    }

    if (resp.data.error) {
      return resp.data.error.description;
    }

    if (!resp.data.data.list) {
      resp.data.data.list = [];
    }

    return resp.data;
  },
  _getMetric: async () => {
    const url = `${Constant.BASE_API}/monitor-smpp/workers`;

    const opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data;
  },
};



// WEBPACK FOOTER //
// ./src/containers/SmppMonitor/service.js